import React from 'react';

// Sponsors / Partners Section
const SponsorsSection = ({ data }) => {
  const { heading = 'Our Sponsors', sponsors = [], background_color } = data || {};
  
  const bgStyle = background_color ? { backgroundColor: background_color } : {};
  
  if (!sponsors || sponsors.length === 0) {
    return null;
  }
  
  return (
    <section className="py-16 px-4" style={bgStyle}>
      <div className="max-w-6xl mx-auto">
        {heading && (
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            {heading}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 items-center justify-items-center">
          {sponsors.map((sponsor, index) => (
            <a
              key={index}
              href={sponsor.url || '#'}
              target={sponsor.url ? '_blank' : '_self'}
              rel="noopener noreferrer"
              className="group"
            >
              {sponsor.logo ? (
                <img
                  src={sponsor.logo}
                  alt={sponsor.name || `Sponsor ${index + 1}`}
                  className="h-16 md:h-20 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                />
              ) : (
                <div className="h-16 md:h-20 px-6 flex items-center justify-center bg-gray-100 rounded-lg">
                  <span className="text-gray-600 font-medium">{sponsor.name}</span>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
